import React from "react";

export default function Incompleted({
  inspectionFilter,
  startInspection,
  showType,
  notUsed,
  type,
  title,
  countOps,
  existsInDatabase,
}) {
  return (
    <ul className="list-unstyled" style={{ width: "100%" }}>
      {inspectionFilter("incomplete", type).map((inspection) => (
        <li
          key={title(inspection) + "_" + inspection.id}
          style={{
            display: "flex",
            gap: "5px",
          }}
        >
          {inspection.oos && (
            <span
              title={title(inspection)}
              onClick={() =>
                existsInDatabase(inspection) && startInspection(inspection)
              }
              style={{
                whiteSpace: "normal",
                position: "relative",
                cursor: existsInDatabase(inspection) ? "pointer" : "text",
                backgroundColor: existsInDatabase(inspection) ? "" : "gray",
                border: existsInDatabase(inspection) ? "" : "1px solid gray",
                width: type === "daily" || type === "weekly" ? "80%" : "100%",
              }}
              className={
                "btn btn-danger btn-inspection" +
                (inspection.status === 10 ? " background-orange" : "")
              }
            >
              {countOps > 1 && (
                <sup
                  style={{
                    position: "absolute",
                    top: "9px",
                    left: "3px",
                  }}
                >
                  {inspection.operationShortName}
                </sup>
              )}
              <span>{inspection.title}</span>(<strong>OOS</strong>)
              {inspection.type !== "daily" && (
                <span>
                  - {showType && <span>{inspection.abbreviation}</span>}
                  <span style={{ textTransform: "initial" }}>
                    <br />
                    Due:&nbsp;{inspection.complianceWindow}
                  </span>
                </span>
              )}
            </span>
          )}
          {!inspection.oos && (
            <div
              title={`${inspection.title} (${
                inspection.offline_number ? inspection.offline_number + "/" : ""
              }${inspection.done}/${inspection.count}) ${inspection.niceType}`}
              onClick={() =>
                existsInDatabase(inspection) && startInspection(inspection)
              }
              className={
                "btn btn-danger btn-inspection" +
                (inspection.status === 10 ? " background-orange" : "")
              }
              style={{
                whiteSpace: "normal",
                position: "relative",
                width: type === "daily" || type === "weekly" ? "80%" : "100%",
                cursor: existsInDatabase(inspection) ? "pointer" : "text",
                backgroundColor: existsInDatabase(inspection) ? "" : "gray",
                border: existsInDatabase(inspection) ? "" : "1px solid gray",
              }}
            >
              {countOps > 1 && (
                <sup
                  style={{
                    position: "absolute",
                    top: "9px",
                    left: "3px",
                  }}
                >
                  {inspection.operationShortName}
                </sup>
              )}
              <span>{inspection.title}</span>
              {(inspection.type === "daily" ||
                inspection.type === "weekly") && (
                <span>
                  (
                  {!!inspection.offline_number && (
                    <span>{inspection.offline_number}/</span>
                  )}
                  <span>{inspection.done}</span>/<span>{inspection.count}</span>
                  )
                </span>
              )}

              {inspection.type !== "daily" && (
                <span>
                  {" "}
                  - {showType && <span>{inspection.abbreviation}</span>}
                  <span style={{ textTransform: "initial" }}>
                    <br />
                    Due:&nbsp;{inspection.complianceWindow}
                  </span>
                </span>
              )}
            </div>
          )}
          {(inspection.type === "daily" || inspection.type === "weekly") &&
            inspection.allow_nu &&
            !inspection.nuloading && (
              <>
                {" "}
                <div
                  style={{
                    cursor: "pointer",
                    whiteSpace: "normal",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => notUsed(inspection)}
                  className={
                    "btn btn-danger btn-not-used" +
                    (inspection.status === 10 ? " background-orange" : "")
                  }
                >
                  NU
                </div>
              </>
            )}
          {inspection.nuloading && (
            <>
              {" "}
              <span className="btn btn-danger btn-not-used">
                <i className="fa fa-cog fa-spin"></i>
              </span>
            </>
          )}
        </li>
      ))}
    </ul>
  );
}
